"use client";

import { c as _c } from "react/compiler-runtime";
import { useShallow } from "zustand/react/shallow";
import { ItemsCountProvider } from "@/components/items/ItemsCount";
import { useIsOwnProfileAddress } from "@/components/profile/ProfileAddressProvider";
import { useProfileTokensSelectionStore } from "./ProfileTokensSelectionProvider";
export function ProfileTokensCountProvider(t0) {
  const $ = _c(6);
  const {
    totalCount,
    hasMore: t1,
    fetching: t2,
    children
  } = t0;
  const hasMore = t1 === undefined ? false : t1;
  const fetching = t2 === undefined ? false : t2;
  const isOwnProfileAddress = useIsOwnProfileAddress();
  const selectedTokensMapSize = useProfileTokensSelectionStore(useShallow(_temp));
  const selectedCount = isOwnProfileAddress ? selectedTokensMapSize : 0;
  let t3;
  if ($[0] !== children || $[1] !== fetching || $[2] !== hasMore || $[3] !== selectedCount || $[4] !== totalCount) {
    t3 = <ItemsCountProvider fetching={fetching} hasMore={hasMore} selectedCount={selectedCount} totalCount={totalCount}>{children}</ItemsCountProvider>;
    $[0] = children;
    $[1] = fetching;
    $[2] = hasMore;
    $[3] = selectedCount;
    $[4] = totalCount;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(v) {
  return v.selectedTokensMap.size;
}